const ENDPOINTS = {
  REDIRECT_URL: "/redirects/getredirectlink",
  STORE_INFO: "/redirects/getfsgraphstores",
};

export  default ENDPOINTS;